import React from "react";

export interface OptionItemProps {
  /** Left icon */
  icon?: React.ReactNode;
  label: string;
  /** Supportive icon */
  decorator?: React.ReactNode;
  support?: string;
  value: string;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

const styles = {
  default: "text-text-base hover:bg-bg-components-hover cursor-pointer",
  selected: "text-text-base bg-bg-components-pressed cursor-pointer",
  disabled: "text-text-disabled bg-bg-disabled",
};

const supportStyles = {
  default: "text-text-subtle",
  selected: "text-text-subtle",
  disabled: "text-text-disabled",
};

/** Should ideally only be used within <OptionList /> */
const OptionItem: React.FC<OptionItemProps> = ({
  icon,
  label,
  decorator,
  support,
  value,
  selected,
  disabled,
  onClick,
}) => {
  const status = (() => {
    if (disabled) return "disabled";
    if (selected) return "selected";
    return "default";
  })();

  const style = styles[status];
  const supportStyle = supportStyles[status];

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className={`select-none w-full px-3 py-2 flex flex-row items-center gap-x-3 typography-medium-base ${style}`}
      onClick={!disabled ? onClick : undefined}
    >
      {icon}
      <option value={value} className="flex-1">
        {label}
      </option>
      {support && (
        <span className={`${supportStyle} typography-small-base`}>
          {support}
        </span>
      )}
      {decorator && (
        <span className={supportStyle}>
          {decorator}
        </span>
      )}
    </div>
  );
};

export default OptionItem;
